import React, { useEffect, useState } from "react";
import {
    Grid,
    IconButton,
    InputAdornment,
    TextField,
    Typography,
    } from "../../ui";
import { withStyles } from "../../ui";
import {
  Button,
    FormControl,
    RadioGroup,
    FormControlLabel,
    FormLabel,
    Radio,
    } from "../../ui";

import { useDispatch,
    useSelector } from "react-redux";
import { updateBillItem } from "../../../store/billDetailsSlice";
import SnpButton from "../../global/SnpButton";
import DismissButton from "../../global/DismissButton";
import { isEmpty } from "lodash";
import DialogBox from "../../global/DialogBox";
import { AddCircle,
    RemoveCircle } from "../../ui/icons";
import {
  OfferType,
  STOCKMGMT,
  isFeatureAllowed,
} from "../../../constants/constant";
import { useSnpUI } from "../../global/snpComponent/SnpUiProvider";
import { recalculateBillTotal } from "../../../store/thunk/billCalculatorThunk";
import {
  INITIAL_BILL_ITEM_STATE,
  INITIAL_PRODUCT_DETAILS_STATE,
} from "../../../constants/restoConstant";
import { calculateRestoConversionPrice, getRestoAvailableStock, getRestoConversion,
  isRestoQuantityAllowed, isRestoStockQuantityAllowed } from "../restoBillingConversion";

const BillItemEdit = ({
  productDetails = INITIAL_BILL_ITEM_STATE,
  billItemDetails = INITIAL_PRODUCT_DETAILS_STATE,
  showEditDailog,
  setShowEditDialog,
  isPaid = false,
}) => {
  const [itemWiseOffer, setItemWiseOffer] = useState(false);
  const dispatch = useDispatch();
  const storeApiUrl = useSelector(
    (state) => state.setApiUrlReducer.MAINURL.INITIAL_BASE_URL
  );
  const [localQuantity, setLocalQuantity] = useState(billItemDetails.quantity);
  const [billNote, setBillNote] = useState("");

  const { snackbar, dialog, notify } = useSnpUI();

  // useEffect( ()=>{
  //   console.log("comp loaded: ", productDetails, billItemDetails);
  //   console.log("localQuantity", localQuantity);

  // },[])

  useEffect(() => {
    setLocalQuantity(billItemDetails.quantity);
    setBillNote(billItemDetails.note);
  }, [billItemDetails.quantity]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    if (name === "note") {
      setBillNote(value);
    } else if (name === "quantity"
      && isRestoQuantityAllowed({ ...productDetails, ...billItemDetails }, value)) {
      setLocalQuantity(value);
    }
  };

  const handleUpdateBillItem = () => {
    const stockItem = { ...productDetails, ...billItemDetails };
    if (!isRestoQuantityAllowed(stockItem, localQuantity)) {
      snackbar.show({ message: "Quantity cannot contain decimal or fraction", color: "red" });
      return;
    }
    if (isFeatureAllowed(STOCKMGMT)
      && !isRestoStockQuantityAllowed(stockItem, localQuantity, billItemDetails.selectedUnit)) {
      const availableStock = getRestoAvailableStock(stockItem, billItemDetails.selectedUnit);
      snackbar.show({
        message: `Exceeds available stock (${availableStock} ${billItemDetails.selectedUnit || getRestoConversion(stockItem)?.unitName || ""})`,
        color: "red",
      });
      return;
    }
    const oldPrice = Number(billItemDetails.finalPrice) || 0;
    const pricedItem = calculateRestoConversionPrice(billItemDetails, localQuantity,
      billItemDetails.selectedUnit);
    const updatedTotalPrice = pricedItem.finalPrice;
    dispatch(
      updateBillItem({
        ...billItemDetails,
        ...pricedItem,
        note: billNote,
      })
    );
    dispatch(
      recalculateBillTotal({
        prevTotalPrice: oldPrice,
        newTotalPrice: updatedTotalPrice,
      })
    );
    setShowEditDialog(false);
    snackbar.show({
      message:
        localQuantity + "* " + (billItemDetails) + " added successfully",
      color: "green",
      vertical: "top",
      horizontal: "right",
    });
  };
  const getProductName = (data) => {
    let name = data.name;
    if (!isEmpty(data.price.name)) name = name + "(" + data.price.name + ")";
    return name;
  };

  const handleDialogClose = () => {
    setShowEditDialog(false);
    setLocalQuantity(billItemDetails.quantity);
  };

  const renderDialogActions = () => {
    return (
      <>
        <SnpButton
          disabled={isPaid}
          variant="contained"
          color="primary"
          onClick={handleUpdateBillItem}
        >
          Update
        </SnpButton>

        <DismissButton
          variant="contained"
          color="primary"
          onClick={handleDialogClose}
        >
          Cancel
        </DismissButton>
      </>
    );
  };
  const BrownTextTypography = withStyles({
    root: {
      color: "#A52A2A",
    },
  })(Typography);

  const renderEditItem = () => {
    console.log("render Edit", billItemDetails.quantity);

    return (
      showEditDailog && (
        <div>
          <Grid container spacing={0}>
            <Grid
              item
              xs={12}
              md={12}
              sm={12}
              lg={12}
              style={{ textAlign: "center" }}
            >
              {productDetails.productImage &&productDetails.productImage.length > 0 && productDetails.productImage[0] && (
                <img
                  alt=""
                  style={{
                    height: "100px",
                    width: "100px",
                    borderRadius: "40%",
                  }}
                  src={
                    storeApiUrl.BASE_IMAGE_URL + productDetails.productImage[0]
                  }
                />
              )}
              <br />
              <Typography variant="p">
                {"Cateogory : " + productDetails.catgName}
              </Typography>
              <br />
              <Typography variant="p" className="shop-details resto-price">
                {productDetails.ingredients}
              </Typography>
            </Grid>
            <Grid item xs={12} md={12} sm={12} lg={12}>
              <FormControl component="fieldset">
                <FormLabel component="legend">Rate Card</FormLabel>
                {/* <RadioGroup aria-label="rate-select" name="rate-select" value={billItemDetails.priceIndex} onChange={handleInputChange}>
                                                  {[...productDetails.price].map((data,index) => (
                                                      <div>
                                                          <FormControlLabel control={<Radio
                                                              value={index}
                                                              id={data.sAmt}
                                                          />}
                                                              label="" />
                                                          <Typography variant="p" className="shop-details shop-address" >{billItemDetails.name + (!isEmpty(data.name) ? "(" + data.name + ")" : "")}</Typography>
                                                          <br /> {"       "}
                                                          <Typography variant="p" className="shop-details resto-price" >Price : &#8377;{data.sAmt}</Typography>
                                                      </div>
                                                  ))}
                                              </RadioGroup> */}
                <RadioGroup
                  aria-label="rate-select"
                  name="rate-select"
                  value={billItemDetails.priceIndex}
                  onChange={handleInputChange}
                >
                  <div>
                    <FormControlLabel
                      control={
                        <Radio value={0} id={productDetails.price.sAmt} />
                      }
                      label=""
                    />
                    <Typography
                      variant="p"
                      className="shop-details shop-address"
                    >
                      {billItemDetails.name +
                        (!isEmpty(productDetails.price.name)
                          ? "(" + productDetails.price.name + ")"
                          : "")}
                    </Typography>
                    <br /> {"       "}
                    <Typography
                      variant="p"
                      className="shop-details resto-price"
                    >
                      Price : &#8377;{productDetails.price.sAmt}
                    </Typography>
                  </div>
                </RadioGroup>
              </FormControl>
            </Grid>
          </Grid>
          <br />
          {itemWiseOffer && (
            <div>
              <FormControl component="fieldset">
                <FormLabel component="legend">Any Offer</FormLabel>
                <RadioGroup
                  row
                  aria-label="offerDenom"
                  name="offerDenom"
                  value={billItemDetails.offerDenom.toString()}
                  onChange={handleInputChange}
                >
                  <FormControlLabel
                    value={OfferType.Flat.toString()}
                    control={<Radio />}
                    label="Discount In Flat"
                  />

                  <FormControlLabel
                    value={OfferType.Percentage.toString()}
                    control={<Radio />}
                    label="Discount In Percentage"
                  />
                  <FormControlLabel
                    value={OfferType.No_Offer.toString()}
                    control={<Radio />}
                    label="No Offer"
                  />
                </RadioGroup>
              </FormControl>
              <br />
              <br />
            </div>
          )}

          <div style={{ paddingBottom: "3px" }}>
            <Grid container spacing={3}>
              {itemWiseOffer && billItemDetails.offerDenom > 1 && (
                <Grid item xs={12} md={6} sm={6} lg={6}>
                  <TextField
                    id="offerAmt"
                    name="offerAmt"
                    variant="filled"
                    size="small"
                    label="Enter Offer Value"
                    value={billItemDetails.offerAmt.toString()}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                  />
                </Grid>
              )}
              <Grid item xs={12} md={6} sm={6} lg={6}>
                <TextField
                  id="quantity"
                  name="quantity"
                  // className={colQuantityClasses.input}
                  type="number"
                  inputMode={getRestoConversion({ ...productDetails, ...billItemDetails })
                    ?.decimalSmRestrictions ? "numeric" : "decimal"}
                  inputProps={{
                    step: getRestoConversion({ ...productDetails, ...billItemDetails })
                      ?.decimalSmRestrictions ? 1 : "any",
                    min: 0,
                  }}
                  value={localQuantity}
                  variant="standard"
                  size="small"
                  sx={{
                    width: "100%",
                    justifyContent: "center",
                    alignContent: "center",
                    "& .UiInputBase-input": {
                      textAlign: "center",
                    },
                  }}
                  label="Enter Quantity"
                  onChange={handleInputChange}
                  InputProps={{
                    min: "0",
                    startAdornment: (
                      <InputAdornment position="start">
                        <IconButton
                          onClick={() => {
                            //  
                            console.log(
                              "incrementing quqntity:",
                              localQuantity
                            );

                            const incrementedQuantity =
                              Number(localQuantity) + 1;
                            const stockItem = { ...productDetails, ...billItemDetails };
                            if (isFeatureAllowed(STOCKMGMT)
                              && !isRestoStockQuantityAllowed(stockItem, incrementedQuantity,
                                billItemDetails.selectedUnit)) {
                                const availableStock = getRestoAvailableStock(stockItem,
                                  billItemDetails.selectedUnit);
                                snackbar.show({
                                  message: `Exceeds available stock (${availableStock} ${billItemDetails.selectedUnit || getRestoConversion(stockItem)?.unitName || ""})`,
                                  color: "red",
                                });
                            } else {
                              setLocalQuantity(incrementedQuantity);
                            }
                          }}
                        >
                          <AddCircle
                            color="success"
                            sx={{
                              fontSize: "2rem",
                            }}
                          />
                        </IconButton>
                      </InputAdornment>
                    ),
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => {
                            if (localQuantity > 0) {
                              let decrementedQuantity = localQuantity - 1;

                              if (decrementedQuantity < 0)
                                decrementedQuantity = 0; // ???
                              setLocalQuantity(decrementedQuantity);
                            }
                          }}
                        >
                          <RemoveCircle
                            color="warning"
                            sx={{
                              fontSize: "2rem",
                            }}
                          />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
            </Grid>
          </div>

          <BrownTextTypography variant="p" sx={{ color: "#00333E", pb: 1 }}>
            Selling Price : {localQuantity}
            {parseInt(billItemDetails.offerDenom) === OfferType.No_Offer
              ? " x " + billItemDetails.price + " = "
              : parseInt(billItemDetails.offerDenom) === OfferType.Flat
              ? " x (" +
                billItemDetails.price +
                " - Flat " +
                billItemDetails.offerAmt +
                ") = "
              : " x (" +
                billItemDetails.price +
                " - " +
                billItemDetails.offerAmt +
                "%) = "}{" "}
            &#8377; {(Number(billItemDetails.price) * localQuantity).toFixed(2)}
            <br />
            {"(Excluded GST@" +
              (parseFloat(productDetails.sgst) +
                parseFloat(productDetails.cgst)) +
              "%)"}
          </BrownTextTypography>
          <Grid container spacing={0}>
            <Grid item md={12} xs={12} lg={12} sm={12}>
              <TextField
                id="note"
                name="note"
                variant="filled"
                size="small"
                rows={3}
                multiline
                onChange={handleInputChange}
                label="Note(If Any)"
                value={billNote}
                sx={{ width: "100%" }}
              />
            </Grid>
          </Grid>
        </div>
      )
    );
  };

  return (
    <div>
      <DialogBox
        showDialog={showEditDailog}
        title={"Update Item"}
        onClose={handleDialogClose}
        dialogContent={renderEditItem()}
        dialogActions={renderDialogActions()}
      />
    </div>
  );
};

export default BillItemEdit;
